import _ from 'lodash'
import { DateTime } from 'luxon'

import { Mission } from '@/features/missions/types/mission'

const status = [
  { slug: 'open', label: 'Aberto' },
  { slug: 'soon', label: 'Em breve' },
  { slug: 'closed', label: 'Fechado' }
]

export const getStatus = (mission: Mission) => {
  const { start_at, end_at } = mission
  const now = DateTime.local()
  const startAt = DateTime.fromISO(start_at || '')
  const endAt = DateTime.fromISO(end_at || '')

  let slug = 'open'
  if (now < startAt) slug = 'soon'
  else if (endAt && endAt.isValid && now >= endAt) slug = 'closed'

  return _.find(status, { slug })
}
